export default function StatsSection() {
  const stats = [
    { value: '10,000+', label: '累计爆料帖' },
    { value: '500+', unit: '人', label: '签约爆料人' },
    { value: '98%', label: '爆料准确率' },
    { value: '24H', label: '实时更新追踪' },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <p className="text-xs text-foreground-500 tracking-wider mb-8">
          爆料吃瓜网 · 数据说话
        </p>

        <div className="max-w-3xl mb-14">
          <p className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-50 leading-relaxed">
            爆料吃瓜网作为国内领先的娱乐八卦资讯平台，拥有超过<strong className="text-primary-400">10,000条</strong>独家爆料帖，签约超过<strong className="text-accent-400">500位</strong>一线爆料人，以<strong className="text-primary-400">98%</strong>的准确率成为吃瓜群众最信赖的吃瓜资源平台。
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {stats.map((stat) => (
            <div key={stat.label}>
              <div className="flex items-baseline gap-1">
                <span className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-50">
                  {stat.value}
                </span>
                {stat.unit && (
                  <span className="text-lg text-foreground-400 font-medium">{stat.unit}</span>
                )}
              </div>
              <p className="mt-2 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}